// eslint-disable-next-line import/prefer-default-export
export const getSystemReport = state => state.system.report;
